import { type FC, memo } from "react";
import { BaseDateCardMobile } from "./BaseDateCardMobile";

interface Props {
  count?: number;
}

export const MobileCalendarLoadingSkeleton: FC<Props> = memo(({ count = 3 }) => (
  <>
    {Array.from({ length: count }, (_, i) => (
      <BaseDateCardMobile key={`skeleton-${i}`} loading />
    ))}
  </>
));

MobileCalendarLoadingSkeleton.displayName = "MobileCalendarLoadingSkeleton";
